module.exports = __webpack_public_path__ + "static/media/plan-crm.f227fa6e.png";